import { z } from 'zod';
import { IDENTIFY_CATEGORIES } from './identifyCategories';

export const MAX_IDENTIFY_IMAGES = 6;
export const NAME_WORDS = 10;
export const MAX_NAME = 80;
export const MAX_DESCRIPTION = 600;

const text = z.string().max(500);
const categoryName = z.enum(IDENTIFY_CATEGORIES.map((c) => c.name));
const tags = z.array(z.string().max(40)).max(10);

export const ModelOutput = z.object({
  name: z.string().min(1).max(MAX_NAME),
  description: z.string().min(1).max(MAX_DESCRIPTION),
  condition: text,
  category: categoryName,
  materials: text,
  technique: text,
  dimensions: text,
  tags,
});
export type ModelOutput = z.infer<typeof ModelOutput>;

export const IdentifyResult = z.object({
  name: z.string().min(1).max(MAX_NAME),
  description: z.string().min(1).max(MAX_DESCRIPTION),
  condition: text.default(''),
  materials: text,
  dimensions: text,
  category: categoryName,
  tags,
  confidence: z.number().min(0).max(1),
  model: z.string(),
});
export type IdentifyResult = z.infer<typeof IdentifyResult>;

export const IdentifyRequest = z.object({
  images: z.array(z.string().min(1)).min(1).max(MAX_IDENTIFY_IMAGES),
});
